import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

import { useState } from "react";
import './SettingPageuser.css'


const EditModalDam=()=>{
    const [selectedDay, setSelectedDay] = useState('');


    const renderCustomInput = ({ ref }) => (
        <>
          <input
        name="birth"
        autoComplete="off"
        ref={ref} // necessary
        placeholder='تاریخ تولد'
        value={selectedDay?`${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`:''}
        className="opop" // a styling class
      />
      <label for="" class="labelSS">تاریخ تولد</label>
      
        </>
      )

    return <div className='show-modal '>
        <div className="editModalDamCon Ani" >
            <div className="editModalDamConHead">
            <h4>ایجاد دام جدید</h4>
            </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a"/>
            <label for="" className={'labelSS'}>شماره گوش</label>
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a"/>
            <label for="" className={'labelSS'}>شماره بدن</label>
        </div>
        
        <div class="inputContainerSS">
                           <DatePicker
                            value={selectedDay}
                            onChange={setSelectedDay}
                             className='inputSS'
                              locale='fa'
                              calendarClassName="birthCalender"
                              renderInput={renderCustomInput}/>
                              
                       </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a"/>
            <label for="" className={'labelSS'}>کد سنسور</label>
        </div>
        <div className="SelConn">
        <label for='sele' >جایگاه:</label>
        <select  id='sele' value='جایگاه پر شیر' name='sele' className="selectInp">
            
            <option>
                جایگاه خشک
            </option>
            <option>
                جایگاه پر شیر
            </option>
            <option>
                 جایگاه انتظار زایش 
            </option>
        </select>
        </div>
        <div className="SelConn">
        <label for='sele' >جنسیت:</label>
        <select id='sele' name='sele' className="selectInp">
            
            <option>
                نر
            </option>
            <option>
                ماده
            </option>
        </select>
        </div>
        <button className="EditMOdalBtnForm">
            به روز رسانی
        </button>
        </div>


    </div>
}
export default EditModalDam